export const interiorPages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/cdMDj6KCtQHq3nYqeYWudi/Captura-de-pantalla-2026-09-18-a-la_s_-5.52.06_p.-m..webp',
    alt: 'Case Study 3: Hard start after fuel system service — complaint, inspection, evidence, repair and before/after fuel circuit diagram',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8fnn8cjM2oTM2v2irTRDPn/Captura-de-pantalla-2026-09-18-a-la_s_-5.51.35_p.-m..webp',
    alt: 'Injector electrical diagnostics — ECM driver circuit, harness, connector and injector with numbered fault check points',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/i6MV53zCN4shs6zQKTgaYp/Captura-de-pantalla-2026-09-18-a-la_s_-5.50.28_p.-m..webp',
    alt: 'Preliminary fuel system inspection — 12-point checklist with fuel circuit diagram and component examples',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rCCcNeg79fCxrL6Nj6R7or/Captura-de-pantalla-2026-09-18-a-la_s_-5.50.50_p.-m..webp',
    alt: 'Fuel quality and contamination diagnostics — fuel sample comparison and contamination workflow',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4qWqoC7gK6EraMGXKrAQzY/Captura-de-pantalla-2026-09-18-a-la_s_-5.51.07_p.-m..webp',
    alt: 'High-pressure pump function and diagnostic role — cutaway diagram and low rail pressure cause map',
  },
];
